import { render, staticRenderFns } from "./PlainTable.vue?vue&type=template&id=371efa97&"
import script from "./PlainTable.vue?vue&type=script&lang=js&"
export * from "./PlainTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pedroasilva/Desktop/ioScienceThesis/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VDataTable,VDivider,VIcon,VSpacer,VToolbar,VToolbarTitle})
